import { render, staticRenderFns } from "./ChallengeRules.vue?vue&type=template&id=0827ed1a"
import script from "./ChallengeRules.vue?vue&type=script&lang=js"
export * from "./ChallengeRules.vue?vue&type=script&lang=js"
import style0 from "./ChallengeRules.vue?vue&type=style&index=0&id=0827ed1a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports